module.exports = __webpack_public_path__ + "static/media/instagram.46a406fd.svg";